<script setup lang="ts">
definePageMeta({
  middleware: ['sync-locale'],
})

const route = useRoute()
const formula = route.params.formula as string
const category = route.params.category as string
const lang = route.params.lang as string

const { styles } = useVariants('page')
const theme = useTheme()

const { data, error, status } = useFetch<MenusResponse>(
  `/api/menu/${formula}/${category}/${lang}`,
)

watch(error, (err) => {
  if (err) showError({ statusCode: err.statusCode ?? 500, fatal: true })
}, { immediate: true })

watch(data, (val) => {
  if (val?.menus.length === 1) {
    navigateTo(`/${formula}/${category}/${lang}/${val.menus[0]!.url}`, { replace: true })
  }
}, { immediate: true })

watch(() => data.value?.theme?.url, (url) => {
  if (url) theme.value = toThemeName(url)
}, { immediate: true, flush: 'sync' })

useHead(() => ({
  bodyAttrs: {
    'data-theme': theme.value,
  },
}))
</script>

<template>
  <section :class="styles.section()">
    <div :class="styles.container()">
      <!-- Loading state -->
      <template v-if="status === 'pending'">
        <Spinner />
      </template>

      <!-- Success state -->
      <template v-else-if="data?.menus.length">
        <ThemeLogo />

        <!-- Title -->
        <h1 :class="styles.heading()">
          {{ $t("menu") }}
        </h1>

        <!-- Menus -->
        <ul v-if="data?.menus.length" class="flex w-full flex-col gap-3">
          <li v-for="menu in data.menus" :key="menu.id" class="w-full">
            <LanguageButton :to="`/${formula}/${category}/${lang}/${menu.url}`" :label="menu.name" />
          </li>
        </ul>
      </template>
    </div>
  </section>
</template>
